export type ILoan = {
  _id?: string;
  createdAt: Date;
  updatedAt: Date;
  companyId: string;
  status: LOAN_STATUS;
  renterInfo: RenterData;
  paymentInfo: PaymentData;
  subscriptionInfo: SubscriptionData[];
  loanCalculation: loanCalculation;

}

export enum LOAN_STATUS {
  UNDEFINED = "undefined",
  PENDING = "pending",
  APPROVED = "approved",
  REPROVED = "reproved",
  CANCELED = "canceled",
  UNDER_ANALYSIS = "under_analysis"
}

export type RenterData = {
  renterId: string;
  renterName: string;
  email: string;
  whatsapp: string;
  cpf: string;
  vehicleId: string
  licensePlate: string
}

export type SubscriptionData = {
  subscriptionId: string;
  totalPayments: number;
  paymentReceived: number;
  paymentPending: number;
};

export type PaymentData = {
  externalPaymentsIds: string[];
  totalAmountPending: number;
}

export type loanCalculation = {
  principalValue: number;
  weeklyRate: number;
  paymentAmount: number;
  numberOfWeeks: number;
  numberOfWeeksRounded: number;
  totalAmount: number;
  totalInterest: number;
  totalToPrincipalRatio: number;
  ruleApplied: "standard" | "high";
  monthlyEquivalentRate: number;
  annualEquivalentRate: number;
  calculatedAt: Date | null;
  isCalculationValid: boolean;
}
export interface ILoanRequest {
  renterInfo: {
    renterName: string;
    renterId: string;
  };
  paymentInfo: {
    externalPaymentsIds: string[];
    ids: string[];
    totalValue: number;
  };
}

export const emptyLoan = () => ({
  _id: "",
  createdAt: new Date(),
  updatedAt: new Date(),
  companyId: "",
  status: LOAN_STATUS.UNDER_ANALYSIS,
  renterInfo: {
    renterId: "",
    renterName: "",
    email: "",
    whatsapp: "",
    cpf: "",
    vehicleId: "",
    licensePlate: "",
  },
  paymentInfo: {
    externalPaymentsIds: [],
    totalAmountPending: 0,
  },
  subscriptionInfo: [],
  loanCalculation: {
    principalValue: 0,
    weeklyRate: 0,
    paymentAmount: 0,
    numberOfWeeks: 0,
    numberOfWeeksRounded: 0,
    totalAmount: 0,
    totalInterest: 0,
    totalToPrincipalRatio: 0,
    ruleApplied: "standard" as const, // ✅ Use literal type
    monthlyEquivalentRate: 0,
    annualEquivalentRate: 0,
    calculatedAt: null,
    isCalculationValid: false
  }
})

